export default [
  {
    name: 'userAgent',
    path: '/gk/test/userAgent',
    component: () => import('@/views/test/userAgent.vue'),
  },
];
